import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Icon, Responsive, Form, TextArea, Sidebar, Container } from 'semantic-ui-react';
import MenuItem from '../menu/MenuItem';
import SelectionGroup from './SelectionGroup';
import AddItemToCartButton from '../menu/AddItemToCartButton';
import { getMenu } from '../../../selectors';
import { setItemToConstruction, removeItemFromConstruction } from '../../../actions';
import { updateItemSelections, getItemSelectionGroups, prepareCartItem } from '../../../helpers/menu-helpers';
import i18next from 'i18next';

import './ItemToConstruction.scss';

const ItemToConstruction = (props) => {
    const dispatch = useDispatch();
    const menu = useSelector(getMenu);
    const cartItem = useSelector(state => state.order.itemInConstruction);
    const cartItemsToAnimate = useSelector(state => state.ui.cartItemsToAnimate);

    function renderSelections() {
        return getItemSelectionGroups(menu.catalog, cartItem).reduce((selectionGroups, cat) => {
            const currSelections = cartItem.selections[cat.id] || [];
            const menuItem = menu.catalog.items[cartItem.id];

            selectionGroups.push(
                <SelectionGroup
                    key={cat.id}
                    categoryId={cat.id}
                    selections={currSelections}
                    onSelected={(itemId, amount) => {
                        const selections = updateItemSelections(menu.catalog, cartItem, { categoryId: cat.id, cartItem: prepareCartItem(menu.catalog, itemId), amount });
                        dispatch(setItemToConstruction({ ...cartItem, selections }));
                    }}
                />
            );

            if (menuItem.options.enableThirdLevel) {
                currSelections.forEach(ci => {
                    getItemSelectionGroups(menu.catalog, ci).forEach(cat2 => {
                        selectionGroups.push(
                            <SelectionGroup
                                key={cat.id + cat2.id}
                                categoryId={cat2.id}
                                selections={ci.selections[cat2.id] || []}
                                onSelected={(itemId, amount) => {
                                    const selections = updateItemSelections(menu.catalog, ci, { categoryId: cat2.id, cartItem: prepareCartItem(menu.catalog, itemId), amount });

                                    dispatch(setItemToConstruction({
                                        ...cartItem,
                                        selections: {
                                            ...cartItem.selections,
                                            [cat.id]: currSelections.map(i => i.id === ci.id ? { ...ci, selections } : i)
                                        }
                                    }));
                                }}
                            />
                        );
                    });
                });
            }

            return selectionGroups;
        }, []);
    }

    function renderRemarks() {
        return (
            <Form className="pi-cart-item-remark">
                <TextArea
                    rows={1}
                    placeholder={i18next.t('menu.itemRemarks')}
                    value={cartItem.remarks}
                    onChange={(e, { value }) => dispatch(setItemToConstruction({ ...cartItem, remarks: value }))}
                />
            </Form>
        );
    }

    const isRtl = () => {
        return i18next.dir() === 'rtl';
    };

    return (
        <Fragment>
            <Sidebar
                as={Container}
                className="pi-construction-container"
                animation='overlay'
                direction={'bottom'}
                onHide={() => dispatch(setItemToConstruction(null))}
                vertical="true"
                visible={!!cartItem}
                width='very wide'
            >
                {cartItem &&
                    <Card fluid className="pi item-construction">
                        <Icon name="x" size="large" onClick={() => dispatch(removeItemFromConstruction())} style={{ left: isRtl() && 15, right: !isRtl() && 15 }} />
                        <div className="pi-item-container">
                            <MenuItem
                                item={menu.catalog.items[cartItem.id]}
                                unlimitedDesc
                                renderExtra={() => (
                                    <Card.Content extra>
                                        <Responsive minWidth={769}>
                                            <AddItemToCartButton />
                                        </Responsive>
                                    </Card.Content>
                                )}
                            />
                        </div>
                        <div className="pi-selections-container">
                            {renderSelections()}
                            {renderRemarks()}
                            <Responsive maxWidth={768}>
                                <div style={{ marginBottom: 80 }} />
                            </Responsive>
                        </div>
                    </Card>
                }
            </Sidebar>
            <Responsive maxWidth={768}>
                {cartItem && <AddItemToCartButton />}
                {cartItemsToAnimate.map(cartItem => (
                    <div className={`pi-item-to-cart-animation`} key={cartItem.index}>
                        <MenuItem item={menu.catalog.items[cartItem.id]} />
                    </div>
                ))}
            </Responsive>
        </Fragment>
    );
};

export default ItemToConstruction;
